import { AxiosPromise } from 'axios'
import { OrderGetDataBase } from 'types/api/faber/order.type'

import FaberApi from '.'

class OrderAPI {
  /**
   * to get the list of esim orders
   * @returns
   */
  static getAllOrders(faberToken: string): AxiosPromise<OrderGetDataBase> {
    return FaberApi.httpGet('/orders', {
      Authorization: `Bearer ${faberToken}`
    })
  }

  /**
   * to update order payment status
   * @param orderObj
   * @returns
   */
  static updateOrderPaymentStatus(orderObj) {
    return FaberApi.httpPut(
      `/orders/${orderObj.ID}/payment-status`,
      { Authorization: `Bearer ${orderObj.faberToken}` },
      {
        paymentId: orderObj.paymentID,
        paymentStatus: orderObj.paymentStatus
      }
    )
  }
}

export default OrderAPI
